import React from "react";
import "./../../../styles/details.css";
import { Container, Row, Col } from "reactstrap";
import Booking from "./../../../components/Booking/Booking";
import tour1 from "./../../../assets/images/night-banner.jpg";
import tour7 from "./../../../assets/images/night-1.jpg";
import tour2 from "./../../../assets/images/night-2.jpg";
import tour3 from "./../../../assets/images/night-3.jpg";
import tour4 from "./../../../assets/images/night-4.jpg";
import Newsletter from "../../../shared/Newsletter";
import ImageGallery from "../../../components/Gallery/Gallery2";
import { Helmet } from "react-helmet";

const NightOpenJaipur = () => {
  const images = [tour7, tour2, tour3, tour4];
  return (
    <>
      <Helmet>
        <title>OPEN-AIR NIGHT TOUR OF JAIPUR CITY | The Rustic Paths</title>
        <meta name="author" content="The Rustic Paths" />
        <meta
          name="description"
          content="Travel India with a private driver and experience the best of what the country has to offer. We offer a wide range of tour packages to suit your budget and interests, including the Golden Triangle Tour, South India Tour, Rajasthan Tour, Same Day Tour, Char Dham Tour and Short Tour. Our experienced drivers will take care of all the logistics, so you can relax and enjoy your journey."
        />
        <meta name="image" content={tour1} />
      </Helmet>
      <h1 className="centered-title text-3xl font-bold mt-6 mb-4">
        OPEN-AIR NIGHT TOUR OF JAIPUR CITY
      </h1>
      <section>
        <Container>
          <Row>
            <Col lg="12" className="details__container mx-auto">
              <img src={tour1} alt="" />
            </Col>

            <Col lg="8">
              <div className="details__container mx-auto">
                <div className="details__info">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Jaipur - Night Open Air City Tour</li>
                    </ul>
                  </div>

                  <p className="mb-4">Duration: Night Trip</p>

                  <div className="mb-4">
                    <h2
                      className="text-xl font-semibold "
                      style={{ textAlign: "left" }}
                    >
                      Overview:
                    </h2>
                    <p>
                      Experience the beauty of Jaipur illuminated at night with
                      our Jeep Night Tour! This tour offers a unique opportunity
                      to enjoy the sparkling night time views of the city’s
                      forts and palaces in an open-air jeep. Explore Jaipur’s
                      iconic landmarks and see the city come alive after dark.
                      With our knowledgeable guides, you’ll learn about the
                      history and culture of Jaipur as you take in the stunning
                      sights.
                    </p>
                  </div>

                  <div className="mb-4">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Trip Highlights:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>
                      Explore the city after sunset
                      </li>
                      <li>
                      Enjoy night time views of forts and palaces
                      </li>
                      <li>
                      Travel in an open-air jeep for an immersive experience
                      </li>
                      <li>
                      Experience the city's ambiance under the stars
                      </li>
                      <li>
                      Visit popular attractions in Jaipur at night.
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Detailed Itinerary:
                    </h2>

                    {/* Day 1 */}
                    <div>
                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          5:30 PM: Sunset at Nahargarh Fort
                        </summary>
                        <p>
                          Begin your evening with a trip to Nahargarh Fort.
                          Perched on the rugged Aravalli hills, the fort offers
                          panoramic views of Jaipur. Get there just in time to
                          catch a breathtaking sunset. The fort’s elevated
                          location provides a perfect vantage point to see the
                          city bathed in golden hues. Take stunning photographs
                          as the sun sets below the horizon.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          7:00 PM: Light and Sound Show at Amber Fort
                        </summary>
                        <p>
                          Next, head to the magnificent Amber Fort. Positioned
                          beside the serene Maouta Lake, this historic fortress
                          comes alive with a captivating light and sound show.
                          Watch the fort’s history unfold through an impressive
                          display of lights and narration. The show, viewed from
                          the lake’s banks, offers a unique perspective on
                          Jaipur’s rich heritage.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          8:30 PM: Passing by Jal Mahal
                        </summary>
                        <p>
                          After the show, drive past Jal Mahal, the Water
                          Palace. Illuminated at night, the palace seems to
                          float on the tranquil waters of Man Sagar Lake. This
                          architectural marvel’s reflection in the lake is a
                          sight to behold and perfect for night-time
                          photography.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          9:00 PM: Exploring the Old Pink City
                        </summary>
                        <p>
                          Continue your journey through the heart of Jaipur, the
                          Old Pink City. The bustling streets and historic
                          buildings, bathed in vibrant lights, showcase the
                          city’s lively spirit. Driving through this area offers
                          a unique glimpse into Jaipur’s rich cultural tapestry.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          9:30 PM: Photography at Hawa Mahal
                        </summary>
                        <p>
                          Stop briefly at Hawa Mahal, the Palace of Winds. This
                          five-story palace, renowned for its intricate
                          latticework, glows beautifully under the night sky.
                          It’s a photographer’s dream, and the illuminated
                          façade provides a stunning backdrop for memorable
                          photos.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          10:00 PM: Passing by Albert Hall Museum
                        </summary>
                        <p>
                          Drive past the Albert Hall Museum, another
                          architectural gem of Jaipur. The museum, illuminated
                          at night, stands as a testament to the city’s artistic
                          heritage. The sight of this grand building lit up is
                          mesmerizing.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          10:15 PM: Passing Statue Circle and New Vidhan Sabha
                        </summary>
                        <p>
                          As you continue, you’ll pass by Statue Circle, a
                          popular city landmark. Also, see the new Vidhan Sabha
                          building, showcasing Jaipur’s blend of historical and
                          modern architecture. Both landmarks are beautifully
                          lit, adding to the city’s night-time charm.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          10:30 PM: Savoring Indian Cuisine at Masala Chowk
                        </summary>
                        <p>
                          End your tour at Masala Chowk, an open-air food court.
                          Here, you can indulge in a variety of traditional
                          Indian dishes. The diverse culinary offerings,
                          combined with the lively atmosphere, make it a perfect
                          place to conclude your night tour. Taste the rich
                          flavors of Rajasthan and enjoy a satisfying meal under
                          the stars.
                        </p>
                      </details>

                      <p>
                        This night tour offers a perfect blend of scenic views,
                        cultural exploration, and local cuisine, making it a
                        memorable experience in Jaipur.
                      </p>

                      {/* Continue adding details for other days as required */}
                    </div>

                    {/* Continue adding details for other days as required */}
                  </div>
                  <Col lg="12">
                    <h2>Image Gallery</h2>
                    <ImageGallery images={images} />
                  </Col>

                  <Col lg="12">
                    {/* Add the ElfSight testimonial widget div */}
                    <div className="elfsight-app-67d8eea9-b408-49ad-8765-9edf92c75e9a"></div>
                  </Col>
                </div>
              </div>
            </Col>

            <Col lg="4">
              <Booking />
            </Col>
          </Row>
        </Container>
      </section>
      <Newsletter />
    </>
  );
};

export default NightOpenJaipur;
